import React, { useEffect } from 'react';
import {
  CContainer,
  CButton,
} from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import UsersTable from '../../components/UsersTable/UsersTable';
import {
  getUserRequestAction,
  sortUserHistorySortData,
  sortingUserHistoryAction,
} from '../../store/users/usersActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import './Users.scss';

const Users = (props) => {
  const {
    userHistorySortData,
    setSortData,
    sortingUserHistory,
    userData,
    userList,
    getUserRequest,
    user,
  } = props;

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const sessionUserId = localStorage.getItem('sessionUserId');
    const userId = sessionUserId || userData?.sessionUserId;

    if (userId && userId !== 'undefined') {
      getUserRequest({
        data: {
          SessionUserId: String(userId)
        }
      });
    } else {
      console.error('User session not found for fetching users');
    }
  }, [getUserRequest]);

  useEffect(() => {
    if (userHistorySortData) {
      const userData = JSON.parse(localStorage.getItem('user') || '{}');
      const sessionUserId = localStorage.getItem('sessionUserId');
      const userId = sessionUserId || userData?.sessionUserId;

      if (userId && userId !== 'undefined') {
        getUserRequest({
          data: {
            SessionUserId: String(userId)
          }
        });
      }
    }
  }, [userHistorySortData, getUserRequest]);

  function changeSortType(sortType) {
    const newUserHistorySortData = { ...userHistorySortData, sortType };
    setSortData(newUserHistorySortData);
    sortingUserHistory();
  }

  function changeSortKey(sortKey) {
    const newUserHistorySortData = { ...userHistorySortData, sortKey };
    setSortData(newUserHistorySortData);
    sortingUserHistory();
  }

  const handleCreateUser = () => {
    navigate('/users/create');
  };

  return (
    <div className="users-page-container">
      <CContainer>
        <div className="page-header">
          <div className="page-title">
            <h2 className="text-fs-head-sm text-start mb-0">
              {t('userManagement') || 'Kullanıcı Yönetimi'}
            </h2>
            <p className="text-muted mb-0">
              {t('userList') || 'Kullanıcı Listesi'}
            </p>
          </div>
          
          <div className="page-actions d-none d-md-block">
            <CButton
              color="primary"
              onClick={handleCreateUser}
              className="d-flex align-items-center gap-2"
            >
              <CIcon icon={cilPlus} size="sm" />
              {t('createNewUser') || 'Yeni Kullanıcı Oluştur'}
            </CButton>
          </div>
        </div>
        
        <UsersTable 
          changeSortType={changeSortType}
          changeSortKey={changeSortKey}
          userHistorySortData={userHistorySortData}
          userList={userList}
          userData={userData}
        />
      </CContainer>

      {/* Floating Action Button for Mobile */}
      <CButton
        color="primary"
        className="create-user-fab d-md-none"
        onClick={handleCreateUser}
        title={t('createNewUser') || 'Yeni Kullanıcı Oluştur'}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.usersReducer.userData,
    userList: state.usersReducer.userList,
    userHistorySortData: state.usersReducer.userHistorySortData,
    isLoading: state.loadingReducer.isLoading,
    user: state.usersReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSortData: (payload) => {
      dispatch(sortUserHistorySortData(payload));
    },
    sortingUserHistory: (payload) => {
      dispatch(sortingUserHistoryAction(payload));
    },
    getUserRequest: (payload) => {
      dispatch(getUserRequestAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);